export default __webpack_public_path__ + "static/media/german_flag.e4c60c9e.webp";